import { render, staticRenderFns } from "./moreSettings.vue?vue&type=template&id=6b8fa214&scoped=true&"
import script from "./moreSettings.vue?vue&type=script&lang=ts&setup=true&"
export * from "./moreSettings.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./moreSettings.vue?vue&type=style&index=0&id=6b8fa214&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8fa214",
  null
  
)

export default component.exports